import { Controller } from "@hotwired/stimulus"
import { openInstacartLink, csrfToken } from "../helpers/instacart_link"

// Drives the recipe page's "Shop ingredients on Instacart" button so it honors
// the current meal-size scale. POSTs the multiplier read from the
// servings-scaler outlet to build a scaled link; openInstacartLink owns the
// tab-opening, double-tap guard, and fallback-on-failure behavior shared with
// grocery-bulk#shopInstacart.
export default class extends Controller {
  static outlets = ["servings-scaler"]
  static values = { url: String }

  async shop(event) {
    event.preventDefault()
    const scale = this.hasServingsScalerOutlet ? this.servingsScalerOutlet.multiplier : 1
    await openInstacartLink(event.currentTarget, async () => {
      const res = await fetch(this.urlValue, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-CSRF-Token": csrfToken() },
        body: JSON.stringify({ servings_scale: scale })
      })
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const { url } = await res.json()
      return url
    })
  }
}
